module.exports = __webpack_public_path__ + "static/Selection_004-be9ff2dc5a276324bae140a6dd19b943.jpeg";